import React from 'react'
import logo from './logo.png'
import { TypeAnimation } from 'react-type-animation'
import Legitimacy from './legitimacy'
import Features from './features'
import GLOBE from 'vanta/dist/vanta.globe.min'

import Profits from './profits'
import Earnings from './earnings'
import Ending from './ending'
import { useRef, useEffect, useState } from 'react'
const Home = () => {
    const [vantaEffect, setVantaEffect] = useState(null)
    const myRef = useRef(null)
    useEffect(() => {
        if (!vantaEffect) {
            setVantaEffect(
                //     BIRDS({
                //     el: myRef.current
                //   })
                GLOBE({
                    el: myRef.current,
                    mouseControls: true,
                    touchControls: true,
                    gyroControls: false,
                    minHeight: 200.00,
                    minWidth: 200.00,
                    scale: 1.00,
                    scaleMobile: 1.00,
                    color: "#09fafb"
                })
            )
        }
        return () => {
            if (vantaEffect) vantaEffect.destroy()
        }
    }, [vantaEffect])
    return (
        <div>
            <div className='' >
                {/* <div className="d-flex justify-content-center"> */}
                <div ref={myRef} className="container-fluid">
                    <div className="row">
                        <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                            <div className="py-md-5">
                                <div className="py-5">
                                    <div className="py-5 p-md-0">
                                        <div className="py-5 p-md-0">
                                            <div className="py-5">
                                                <div>
                                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>BUILD YOUR</h1>

                                                    <h1 className='' >
                                                        <TypeAnimation
                                                            sequence={[
                                                                // Same substring at the start will only be typed once, initially
                                                                'WEALTH',
                                                                1000,
                                                                'LIFE',
                                                                1000,
                                                                'DREAMS',
                                                                1000,
                                                                'FORTUNES',
                                                                1000,
                                                                'PLANS',
                                                                1000,

                                                                'GOALS',
                                                                1000,
                                                            ]}
                                                            speed={50}

                                                            className="text-light display-4"
                                                            style={{ fontWeight: 'bold' }}
                                                            repeat={Infinity}
                                                        /></h1>
                                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>WITH VTC</h1>
                                                    <p className="text-light display-6">Secure and Grow Your Wealth with</p>
                                                    <p className="text-light h4">VTC's Decentralized Smart Contract Platform</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={`https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://VTC.com.pk${logo}`} class="brand-image p-4 p-md-0" alt="..." />
                    </div> */}
                    </div>
                </div>
                <div className="container-fluid">
                <Legitimacy />
                </div>
            </div>
            <Features />
            <Profits />
            <Earnings />
            <div className="container-fluid py-5">
                <div className="px-md-5">
                    <div className="px-3">
                        <div className="row py-5">
                            <div className="col-md-6 col-12">
                                <h1 className="text-light">Latest VTC Updates
                                </h1>
                                <h4 style={{ fontWeight: 300 }} className="text-light">Stay ahead with the latest VTC news, market trends, and upcoming project updates. Explore new exciting developments shaping the future of decentralized finance!



                                </h4>
                            </div>
                            <div className="d-flex align-items-center justify-content-md-end col-md-6 col-12 px-md-5">
                                <div className="px-md-5">
                                    {/* <p className="text-light">A Smarter, More Profitable Way to Invest in Your Financial Future!</p> */}
                                    <button className="btn btn-light">Join Our Community</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid px-md-5 py-md-5">
                <Ending />

            </div>
        </div>
    )
}

export default Home